import { render, staticRenderFns } from "./PageClients.vue?vue&type=template&id=6d9844e5"
import script from "./PageClients.vue?vue&type=script&lang=js"
export * from "./PageClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports